import { RangeHorizon } from '@toggle/chart';

import { queryKeys, queryValues } from '~/routes/query-params';

import { useQueryParams } from '../use-query-params/useQueryParams';

export const useInsightsFullDrawer = () => {
  const { setQueryParams, deleteQueryParam } = useQueryParams();

  const openDrawer = ({
    entityTag,
    insightId,
    horizon,
  }: {
    entityTag: string;
    insightId: string;
    horizon?: RangeHorizon;
  }) =>
    setQueryParams({
      [queryKeys.source]: undefined,
      [queryKeys.activeInsight]: undefined,
      [queryKeys.entityTag]: entityTag,
      [queryKeys.activeInsightId]: insightId,
      [queryKeys.activeInsightHorizon]: horizon ?? RangeHorizon.OneMonth,
      [queryKeys.activeDrawer]: queryValues.insightsFullDrawer,
    });

  const closeDrawer = () =>
    deleteQueryParam(
      [
        queryKeys.entityTag,
        queryKeys.activeInsightId,
        queryKeys.activeInsightHorizon,
        queryKeys.activeDrawer,
        queryKeys.utmSource,
        queryKeys.utmCampaign,
      ],
      {
        replace: true,
      }
    );

  return {
    openDrawer,
    closeDrawer,
  };
};
